module.exports = __webpack_public_path__ + "static/img/sjLogin.849fa1b7.png";